import React from 'react'
import { AiOutlineArrowLeft, AiOutlineArrowRight, AiFillStar } from 'react-icons/ai'

const YourHistory = ({ roundNumber, setRoundNumber, currentRoundNumber, drawnTime, winningNumber1,
    winningNumber2,
    winningNumber3,
    winningNumber4,
    winningNumber5,
    winningNumber6,
    winningNumber7,
    poolPrize,
    totalPoolPrize6,
    perPersonPrize6,
    totalPlayer,
    totalPersonPrize6,
    totalPersonPrize5,
    totalPoolPrize5,
    perPersonPrize5,
    totalPersonPrize4,
    totalPoolPrize4,
    perPersonPrize4,
    totalPersonPrize3,
    totalPoolPrize3,
    perPersonPrize3,
    totalPoolPrize2,
    perPersonPrize2,
    totalPersonPrize2,
    totalPoolPrize1,
    perPersonPrize1,
    totalPersonPrize1,
    maintenanceAmount

}) => {
  return (
    <>
        <div className="flex flex-col items-center justify-between px-[5em] pb-5 pt-2">
              <div className="">
                <div className="block px-6 py-4 bg-black/50 rounded-t-2xl border border-black/20 shadow-md cursor-pointer  w-[24em] sm:w-[30em] md:w-[45em]">
                  <div className="flex flex-col space-y-1">
                    <div className="flex justify-between items-center">
                      <div className="flex items-center">
                        <p className="text-lyellow text-xl font-semibold">
                          Round
                        </p>
                        <span className="ml-5 rounded-full bg-[#2a3137] px-3 py-1">
                          {parseInt (roundNumber)}
                        </span>
                      </div>
                      <div className="flex items-center justify-between">
                        <AiOutlineArrowLeft
                          className="mr-2 text-lg"
                          onClick={() => {
                            if (parseInt (roundNumber) - 1 > 0) {
                              setRoundNumber (parseInt (roundNumber) - 1);
                            }
                          }}
                        />
                        <AiOutlineArrowRight
                          className="ml-2 text-lg"
                          onClick={() => {
                            if (roundNumber + 1 < currentRoundNumber) {
                              setRoundNumber (parseInt (roundNumber) + 1);
                            }
                          }}
                        />
                      </div>
                    </div>
                    <p className="text-lyellow">
                      Drawn:
                      {' '}
                      {new Date (parseInt (drawnTime) * 1000).toLocaleString ()}

                      {/* May 17, 2022, 5:00 PM */}
                    </p>
                  </div>
                </div>

                <div className="block p-6 bg-[#2a3137] border border-black/20 shadow-md cursor-pointer w-[24em] sm:w-[30em] md:w-[45em]">
                  <div className="flex flex-col justify-center space-y-5">
                    <div className="flex justify-between items-center">
                      <p className="text-lyellow  font-semibold ">
                        Winning Number
                      </p>
                      <div className="flex flex-grow text-xl text-lyellow items-center">
                        <p className=" ml-4 mr-2 sm:mx-5 shadow-md shadow-zinc-400 rounded-full px-2">
                          {winningNumber1}
                        </p>
                        <p className="mr-2 sm:mr-5 shadow-md shadow-red-400 rounded-full px-2">
                          {winningNumber2}
                        </p>
                        <p className="mr-2 sm:mr-5 shadow-md shadow-blue-400 rounded-full px-2">
                          {winningNumber3}
                        </p>
                        <p className="mr-2 sm:mr-5 shadow-md shadow-green-400 rounded-full px-2">
                          {winningNumber4}
                        </p>
                        <p className="mr-2 sm:mr-5 shadow-md shadow-orange-400 rounded-full px-2">
                          {winningNumber5}
                        </p>
                        <div className="flex">
                          <AiFillStar className="text-[#FFD700] text-sm" />
                          <p className="mr-1 sm:mr-5 shadow-md shadow-yellow-500 rounded-full px-2">
                            {winningNumber6}
                          </p>
                        </div>
                        <div className="flex">
                          <AiFillStar className="text-[#FFD700] text-sm" />
                          <p className="mr-5 shadow-md shadow-yellow-500 rounded-full px-2">
                            {winningNumber7}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="block p-6 bg-[#2a3137] border border-black/20 shadow-md cursor-pointer w-[24em] sm:w-[30em] md:w-[45em]">
                  <div className="flex flex-col justify-center space-y-5">
                    <div className="flex justify-start items-center">
                      <p className="text-lyellow text-xl font-semibold">
                        Prize Pool
                      </p>
                      <div className="pl-20 text-2xl">
                        $ {poolPrize}
                    
                      </div>
                    </div>
                    <div className="flex justify-start items-center">
                      <p className="text-lyellow text-xl font-semibold">
                        Total Tickets Bought
                      </p>
                      <p className="ml-12 text-2xl text-white">
                        {totalPlayer}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="block p-6 bg-black/40 rounded-b-2xl border border-black/20 shadow-md mb-10 cursor-pointer  w-[24em] sm:w-[30em] md:w-[45em]">
                  <div className="flex flex-col justify-center space-y-5">
                    <div className="grid grid-cols-2 md:grid-cols-4">
                      <div className="flex flex-col  m-2">
                        <p className="text-lyellow text-sm font-semibold">
                          2 Numbers
                        </p>
                        <p className="text-lg font-semibold">
                          $ {totalPoolPrize6}
                          
                        </p>
                      
                        <p className="text-xs text-white/70">
                          {' '}$ {perPersonPrize6} Each Player
                        </p>
                        <p className="text-xs text-white/70">
                          {totalPersonPrize6} Winning Tickets
                        </p>
                      </div>
                      <div className="flex flex-col space-y-1 m-2">
                        <p className="text-lyellow text-sm font-semibold">
                          3 Numbers
                        </p>
                        <p className="text-lg font-semibold">
                          $ {totalPoolPrize5}

                        </p>
                        {/* <p className="text-xs text-white/70">~26,20</p> */}
                        <p className="text-xs text-white/70">
                          $ {perPersonPrize5} Each Player
                        </p>
                        <p className="text-xs text-white/70">
                          {totalPersonPrize5} Winning Tickets
                        </p>
                      </div>
                      <div className="flex flex-col space-y-1 m-2">
                        <p className="text-lyellow text-sm font-semibold">
                          4 Numbers
                        </p>
                        <p className="text-lg font-semibold">
                          $ {totalPoolPrize4}
                         
                        </p>
                        {/* <p className="text-xs text-white/70">~4,366</p> */}
                        <p className="text-xs text-white/70">
                          $ {perPersonPrize4} Each Player
                        </p>
                        <p className="text-xs text-white/70">
                          {totalPersonPrize3} Winning Tickets
                        </p>
                      </div>
                      <div className="flex flex-col space-y-1 m-2">
                        <p className="text-lyellow text-sm font-semibold">
                          5 Numbers
                        </p>
                        <p className="text-lg font-semibold">
                          $ {totalPoolPrize3}
                        
                        </p>
                        {/* <p className="text-xs text-white/70">~8,732</p> */}
                        <p className="text-xs text-white/70">
                          $ {perPersonPrize3} Each Player
                        </p>
                        <p className="text-xs text-white/70">
                          {totalPersonPrize3} Winning Tickets
                        </p>
                      </div>
                      <div className="flex flex-col space-y-1 m-2">
                        <p className="text-lyellow text-sm font-semibold">
                          5 Numbers + 1 Starts
                        </p>
                        <p className="text-lg font-semibold">
                          $ {totalPoolPrize2}
                        
                        </p>
                        {/* <p className="text-xs text-white/70">~17,464</p> */}
                        <p className="text-xs text-white/70">
                          $ {perPersonPrize2} Each Player
                        </p>
                        <p className="text-xs text-white/70">
                          {totalPersonPrize2} Winning Tickets
                        </p>
                      </div>
                      <div className="flex flex-col space-y-1 m-2">
                        <p className="text-lyellow text-sm font-semibold">
                          5 Numbers + 2 Starts
                        </p>
                        <p className="text-lg font-semibold">
                          $ {totalPoolPrize1}
                         
                        </p>
                        {/* <p className="text-xs text-white/70">~34.924</p> */}
                        <p className="text-xs text-white/70">
                          $ {perPersonPrize1} Each Player
                        </p>
                        <p className="text-xs text-white/70">
                          {totalPersonPrize1} Winning Tickets
                        </p>
                      </div>
                      <div className="flex flex-col space-y-1 m-2">
                        <p className="text-red-500 text-sm font-semibold">
                          For Maintenance & Stake Holders
                        </p>
                        <p className="text-lg font-semibold">
                          $ {maintenanceAmount}
                        
                        </p>
                      
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
    </>
  )
}

export default YourHistory